import { Component, ContentChild, Input, OnChanges, OnInit, SimpleChanges, TemplateRef } from '@angular/core';
import { DomainFilterType } from 'src/app/model/enum/observations/domain-filter-type.enum';
import { Subdomain } from 'src/app/model/enum/observations/subdomain.enum';
import { DomainLookup } from 'src/app/model/interfaces/DomainLookup.interface';
import { ObservationLookUpTypes } from 'src/app/observations/helpers/observation-lookup-types/observation-lookup-types.helper';

@Component({
    selector: 'app-subdomains-display',
    templateUrl: './subdomains-display.component.html',
    styleUrls: ['./subdomains-display.component.scss']
})
export class SubdomainsDisplayComponent implements OnInit, OnChanges {
    @Input() domains: DomainLookup[] = [];
    @Input() filterType?: DomainFilterType = DomainFilterType.ALL;
    @Input() currentSubdomain?: Subdomain = Subdomain.CONTENT_KNOWLEDGE;
    @Input() focusAreas?: string[] = [];

    @ContentChild(TemplateRef) itemTemplate: TemplateRef<any> | null = null;


    public filteredDomains: DomainLookup[] = [];

    constructor() { }

    ngOnInit(): void {
        this.filterDomains(this.domains, this.filterType, this.currentSubdomain, this.focusAreas);
    }

    ngOnChanges(changes: SimpleChanges): void {
        const domains = changes['domains']?.currentValue;
        const filterType = changes['filterType']?.currentValue;
        const currentSubdomain = changes['currentSubdomain']?.currentValue;
        const focusAreas = changes['focusAreas']?.currentValue;

        if (domains !== undefined || filterType !== undefined || currentSubdomain !== undefined || focusAreas !== undefined) {
            this.filterDomains(domains ?? this.domains, filterType ?? this.filterType, currentSubdomain ?? this.currentSubdomain, focusAreas ?? this.focusAreas);
        }
    }

    private filterDomains(domains: DomainLookup[] = [], filterType?: DomainFilterType, currentSubdomain?: Subdomain, focusAreas?: string[]) {
        this.filteredDomains = ObservationLookUpTypes.filterDomains(domains, filterType, currentSubdomain, focusAreas);
    }
}
